import { isAxiosError } from 'axios'
import { QueryClient } from '@tanstack/react-query'

import { TruckbookApiResponseError } from 'repositories/TruckbookApiResponseError'

/**
 * 納品実績機能（一覧・詳細）で共有する QueryClient。
 *
 * 倉庫一覧（getWarehouses）と納品実績一覧（getTenantShipments）・
 * ユーザー機能フラグ（getUserFeatures）の取得をこの QueryClient 配下で行う。
 * DeliveryDestination 機能の queryClients/deliveryDestination.ts と同方針。
 */
export const deliveryPerformanceQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // 4xx はリトライ不要（422 区分OFF / 404 not found / 401・403 認証 等）。
        // shipmentApiClient は createTruckbookApiErrorInterceptor 配線済みのため 4xx は
        // AxiosError ではなく TruckbookApiResponseError で reject される。両方から status を取る。
        const status =
          error instanceof TruckbookApiResponseError
            ? error.httpStatus
            : isAxiosError(error)
              ? error.response?.status
              : undefined
        if (status != null && status < 500) return false
        return failureCount < 1
      },
    },
  },
})
